<template>
  <div>
    <ts-loading-banner :loading="loading">
      <form class="form-horizontal mt-3">
        <div class="row form-group">
          <div class="col-md-12">
            <label class="required ts-text-xs">{{
              $t('studentScoringEntry.advisor')
            }}</label>
            <select
              class="form-control"
              v-model="model.advisor_id"
              :class="{
                'is-invalid': $v.model.advisor_id.$error
              }"
            >
              <option :value="1">{{
                $t('studentscoringentry.teacher')
              }}</option>
              <option :value="2">
                {{ $t('studentscoringentry.management') }}
              </option>
              <option :value="3">{{ $t('studentscoringentry.parent') }}</option>
            </select>
            <div class="validate" v-if="errors.has('advisor_id')">
              {{ errors.first('advisor_id') }}
            </div>
            <span class="validate" v-if="advisorIdErrors.length > 0">{{
              advisorIdErrors[0]
            }}</span>
          </div>
        </div>
        <div class="row form-group">
          <div class="col-md-12">
            <label class="required ts-text-xs">{{
              $t('studentScoringEntry.comment')
            }}</label>
            <VueEditor
              v-model="model.comments"
              :editor-toolbar="customToolbar"
              useCustomImageHandler
            />
            <div class="validate" v-if="errors.has('comments')">
              {{ errors.first('comments') }}
            </div>
            <span class="validate" v-if="commentsErrors.length > 0">{{
              commentsErrors[0]
            }}</span>
          </div>
        </div>
        <!-- <div class="row form-group">
        <div class="col-md-12">
          <label class="ts-text-xs">{{
            $t('studentScoringEntry.suggesstion')
          }}</label>
          <VueEditor
            v-model="model.suggesstion"
            :editor-toolbar="customToolbar"
            useCustomImageHandler
          />
        </div>
      </div> -->
        <div class="row">
          <div class="col-md-12 text-right">
            <ts-button class="mr-2" @click="onCloseModal">{{
              $t('cancel')
            }}</ts-button>
            <ts-button color="primary" @click.prevent="onOk">{{
              $t('ok')
            }}</ts-button>
          </div>
        </div>
      </form>
    </ts-loading-banner>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import { VueEditor } from 'vue2-editor'
import { required } from 'vuelidate/lib/validators'

export default {
  name: 'advisorComment',
  props: ['value'],
  components: { VueEditor },
  data () {
    return {
      loading: false,
      waiting: false,
      errors: new Errors(),
      model: {},
      customToolbar: [
        [{ font: [] }],
        [{ header: [false, 1, 2, 3, 4, 5, 6] }],
        ['bold', 'italic', 'underline', 'strike'],
        [
          { align: '' },
          { align: 'center' },
          { align: 'right' },
          { align: 'justify' }
        ],
        [{ header: 1 }, { header: 2 }],
        ['blockquote', 'code-block'],
        [{ list: 'ordered' }, { list: 'bullet' }, { list: 'check' }]
      ]
    }
  },
  validations: {
    model: {
      advisor_id: { required },
      comments: { required }
    },
    form: ['model.advisor_id', 'model.comments']
  },
  computed: {
    advisorIdErrors () {
      const errors = []
      if (!this.$v.model.advisor_id.$error) return errors
      !this.$v.model.advisor_id.required && errors.push('Required')
      return errors
    },
    commentsErrors () {
      const errors = []
      if (!this.$v.model.comments.$error) return errors
      !this.$v.model.comments.required && errors.push('Required')
      return errors
    }
  },
  created () {
    this.model = this.value
  },
  methods: {
    onOk () {
      this.$v.form.$touch()
      if (!this.$v.form.$invalid) {
        this.$emit('closeModal')
      }
    },
    onCloseModal () {
      this.clearInput()
      this.$emit('closeModal')
    },
    clearInput () {
      this.model.sc_stu_com_id = 0
      this.model.advisor_id = null
      this.model.comments = null
      this.model.suggesstion = null
    }
  }
}
</script>
